import isDate from 'lodash/isDate';

export const env = process.env.NODE_ENV || 'development';

export const getTimestamp = () => Math.floor(new Date().getTime() / 1000);

export function toTime(date) {
  let theDate = date;

  if (!isDate(theDate)) {
    theDate = new Date(theDate);
  }
  return Math.floor(theDate.getTime() / 1000);
}

export const cdnURL = "https://assets.17app.co/golden_feather/result/";

export const gcpURL = 'https://storage.googleapis.com/media17-prod-web-assets/golden_feather';



// WEBPACK FOOTER //
// ./src/lib/utils.js